import { useDispatch } from 'react-redux';
import { OurServicesWithLoader } from './loaders';

export const OurServices = () => {
    const dispatch = useDispatch();

    return <OurServicesWithLoader />;
};
